import { useFoundingStats } from "../hooks/useFoundingStats";

/**
 * Compact "Founding 50 · X spots left" badge.
 * variant: "light" (cream bg) | "dark" (on forest/brown) | "gold"
 */
export default function FoundingBadge({ variant = "light", size = "md", className = "" }) {
  const { founding_remaining, founding_full, loading } = useFoundingStats();

  const palette =
    variant === "dark"
      ? { bg: "rgba(201, 168, 76, 0.18)", border: "rgba(201, 168, 76, 0.45)", color: "var(--gold-soft)", dot: "var(--gold)" }
      : variant === "gold"
      ? { bg: "var(--gold)", border: "var(--gold)", color: "var(--brown)", dot: "var(--forest)" }
      : { bg: "rgba(201, 168, 76, 0.14)", border: "rgba(201, 168, 76, 0.4)", color: "var(--gold-deep)", dot: "var(--gold-deep)" };

  const sizeCls = size === "sm" ? "text-[10px] px-3 py-1" : "text-xs px-4 py-1.5";

  return (
    <span
      data-testid="founding-badge"
      className={`inline-flex items-center gap-2 rounded-full uppercase tracking-[0.2em] font-medium ${sizeCls} ${className}`}
      style={{
        background: palette.bg,
        color: palette.color,
        border: `1px solid ${palette.border}`,
      }}
    >
      <span className="relative inline-flex w-2 h-2">
        <span
          className="absolute inset-0 rounded-full animate-ping opacity-60"
          style={{ background: palette.dot }}
        ></span>
        <span
          className="relative w-2 h-2 rounded-full"
          style={{ background: palette.dot }}
        ></span>
      </span>
      {loading ? (
        "Founding 50 · loading…"
      ) : founding_full ? (
        "Founding 50 · waitlist full"
      ) : (
        <>
          Founding 50 · <span data-testid="founding-remaining" className="font-semibold tabular-nums">{founding_remaining}</span> spots left
        </>
      )}
    </span>
  );
}
